import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationDetoxificationIntermediaryCombined from "./index";

const MethylationDetoxificationIntermediaryWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationDetoxificationIntermediaryCombined}
    keyControlsId="methylation-detoxification-intermediary-key"
    {...props}
  />
);

export default MethylationDetoxificationIntermediaryWithToggleKey;
